import axios from 'axios';

/**
 * Fetches the SCORM launch link from the API and opens it in a new window
 * @param scormPackageId The ID of the SCORM package to launch
 */
export async function launchScormPackage(scormPackageId: string): Promise<void> {
  const response = await axios.get(`/api/v3/scorm_packages/${scormPackageId}/launch_link`);
  window.open(response.data.response, "_blank");
}